"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Input = styled_components_1.default.input.attrs({
    className: 'tws-editable-input',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tborder: 0;\n\t\toutline: none;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\t&::placeholder {\n\t\t\tcolor: #aaaaaa;\n\t\t}\n\t}\n"], ["\n\t {\n\t\tborder: 0;\n\t\toutline: none;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\t&::placeholder {\n\t\t\tcolor: #aaaaaa;\n\t\t}\n\t}\n"])));
exports.Input.displayName = 'Input';
var templateObject_1;
